module.exports = __webpack_public_path__ + "static/media/DSC_4259.8c97b036.jpg";